import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
import * as _T from "@utils/ClassTypes";
import { useState } from "react";
import Input from "./Input";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// NichosForms => Rename all instances to use
type NichosFormsProps = {
  _disabled?: boolean;
  _saveButton?: string;
} & _Base &
  (
    | {
        _type: "nicho";
        _store: _T.Nicho;
        _onSave?: (ls: _T.Nicho) => void;
      }
    | {
        _type: "seccion";
        _store: _T.Seccion;
        _onSave?: (ls: _T.Seccion) => void;
      }
  );

// ################################ RENDERING COMPONENT ################################
const _NichosForms = (props: NichosFormsProps) => {
  // ------------------------------------------------------------------------------------ LOCAL STATE
  const [LS] = useState({ ...props._store });

  // ------------------------------------------------------------------------------------ HANDLERS
  function handleSaveBtn() {
    console.log("SAVE", LS, props);
    props._onSave?.(structuredClone(LS) as any);
  }

  // ------------------------------------------------------------------------------------ RETURN
  return (
    <div className={props.className}>
      {props._type === "nicho" ? (
        <fieldset>
          <legend>Datos del nicho</legend>

          <Input
            _label={"ID (autogenerado): "}
            _disabled
            _store={LS}
            _store_var={"id"}
            _width={"m"}
          />
          <Input
            _label={"Placa: "}
            _store={LS}
            _store_var={"placa"}
            _width={"l"}
            _disabled={props._disabled}
          />
          <Input
            _label={"Tipo: "}
            _store={LS}
            _store_var={"tipo"}
            _disabled={props._disabled}
            _width={"m"}
          />
          <Input
            _label={"Precio: "}
            _store={LS}
            _store_var={"precio"}
            _preset={"money"}
            _disabled={props._disabled}
          />
          <Input
            _label={"Capacidad: "}
            _store={LS}
            _store_var={"capacidad"}
            _as_number
            _preset={"int"}
            _range={[1, 12, true]}
            _disabled={props._disabled}
          />
          <Input
            _label={"Fila: "}
            _store={LS}
            _store_var={"fila"}
            _disabled
            _width={"xs"}
          />
          <Input
            _label={"Columna: "}
            _store={LS}
            _store_var={"columna"}
            _disabled
            _width={"xs"}
          />
          <Input
            _label={"Unido con: "}
            _store={LS}
            _store_var={"unido_con"}
            _width={"xs"}
            _disabled={props._disabled}
          />
          <Input
            _label={"Vendedor: "}
            _store={LS}
            _store_var={"vendedorID"}
            _disabled={props._disabled}
          />
          <Input
            _label={"Notas adicionales: "}
            _store={LS}
            _store_var={"notas"}
            _type={"textarea"}
            _disabled={props._disabled}
          />
          <button className="secondary" onClick={handleSaveBtn}>
            {props._saveButton}
          </button>
        </fieldset>
      ) : (
        <fieldset>
          <legend>Datos de la sección</legend>

          <Input
            _label={"ID (autogenerado): "}
            _disabled
            _store={LS}
            _store_var={"id"}
            _width={"m"}
          />
          <Input
            _label={"Nombre: "}
            _store={LS}
            _store_var={"nombre"}
            _width={"m"}
            _disabled={props._disabled}
          />
          <Input
            _label={"Orden: "}
            _store={LS}
            _store_var={"orden"}
            _as_number
            _preset={"int"}
            _range={[1, undefined, true]}
            _disabled={props._disabled}
          />
          <Input
            _label={"Filas: "}
            _store={LS}
            _store_var={"filas"}
            _as_number
            _preset={"int"}
            _range={[1, 20, true]}
            _disabled={props._disabled}
          />
          <Input
            _label={"Columnas: "}
            _store={LS}
            _store_var={"columnas"}
            _as_number
            _preset={"int"}
            _range={[1, 20, true]}
            _disabled={props._disabled}
          />
          <Input
            _label={"Color: "}
            _store={LS}
            _store_var={"color"}
            _width={"m"}
            _disabled={props._disabled}
          />
          <Input
            _label={"Notas adicionales: "}
            _store={LS}
            _store_var={"notas"}
            _type={"textarea"}
            _disabled={props._disabled}
          />
          <button className="secondary" onClick={handleSaveBtn}>
            {props._saveButton}
          </button>
        </fieldset>
      )}
    </div>
  );
};

// ################################ STYLES ################################
const NichosForms = styled(_NichosForms).attrs(
  (props: NichosFormsProps): NichosFormsProps => {
    return { _saveButton: "Guardar cambios", ...props };
  }
)`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default NichosForms;
